import { render, staticRenderFns } from "./AppHeaderForceclub.vue?vue&type=template&id=58aabc7a&"
import script from "./AppHeaderForceclub.vue?vue&type=script&lang=js&"
export * from "./AppHeaderForceclub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports